import {combineReducers, configureStore} from '@reduxjs/toolkit'
import {api as authApi} from "@/lib/api/auth/api";
import {api as walletApi} from "@/lib/api/wallet/api";
import {api as gamesApi} from "@/lib/api/games/api";
import {authReducer} from "@/lib/slices/authSlice";
import {uiReducer} from "@/lib/slices/uiSlice";
import {cashierReducer} from "@/lib/slices/cashierSlice";
import {dialogsReducer} from "@/lib/slices/dialogsSlice";
import {cookieSyncMiddleware} from "@/lib/middleware/cookieSyncMiddleware";

const rootReducer = combineReducers({
    [authApi.reducerPath]: authApi.reducer,
    [walletApi.reducerPath]: walletApi.reducer,
    [gamesApi.reducerPath]: gamesApi.reducer,
    auth: authReducer,
    ui: uiReducer,
    cashier: cashierReducer,
    dialogs: dialogsReducer,
})

// Infer the `RootState` from the root reducer so `makeStore` can accept a
// `preloadedState` without a circular type reference through `AppStore`.
export type RootState = ReturnType<typeof rootReducer>

export const makeStore = (preloadedState?: Partial<RootState>) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
        // AC-817: the Redux DevTools extension is the only wrapper around
        // dispatch/getState/subscribe that isn't ours. Keep it out of
        // production; it stays on in `pnpm dev`.
        devTools: process.env.NODE_ENV !== 'production',
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(cookieSyncMiddleware, authApi.middleware, walletApi.middleware, gamesApi.middleware),
    })
}

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = AppStore['dispatch']
